export default "__VITE_ASSET__DVDYL9_F__"